export default __webpack_public_path__ + "static/media/logo.4efb4b68.png";